type HandlePromiseConfig<E> = {
  onError?: (error: E, index: number) => void
}

export async function handlePromises<T, E = Error>(
  promises: Promise<T>[],
  config?: HandlePromiseConfig<E>
): Promise<[T[], Array<{ error: E; index: number }>]> {
  const results = await Promise.allSettled(promises)

  const resolved: T[] = []
  const errors: Array<{ error: E; index: number }> = []

  results.forEach((result, index) => {
    if (result.status === `fulfilled`) {
      resolved.push(result.value)
    } else {
      errors.push({ error: result.reason as E, index })
    }
  })

  if (config?.onError) {
    errors.forEach((error) => {
      if (config.onError) {
        config.onError(error.error, error.index)
      }
    })
  }

  return [resolved, errors]
}
